import { UIIcon } from '../../../config/icons';
import { makeStar } from '../../blk/elements';
import { FPageBlock } from '../../mdl/f-page-block';
import { UITextInput } from '../../ui/component/input';
import { UILabeled } from '../../ui/component/labeled';
import { UICheckbox } from '../../ui/component/toggle';
import { $el } from '../../ui/elements';
import { $on } from '../../y/events';
import { $form } from '../../y/form';
import { EDBlockSpec, EDBlock } from '../block';
import { EDBlockContainer } from '../editor';
import { fakeInput, fakeButton } from '../elements';

export const ed_page_hubspot_block: EDBlockSpec<FPageBlock> = {
    key: 'hubspot',
    editor_block: class extends EDBlock {
        constructor(container: EDBlockContainer) {
            const region = new UITextInput({ kind: 'k-subtle' });
            const portal_id = new UITextInput({ kind: 'k-subtle' });
            const form_id = new UITextInput({ kind: 'k-subtle' });

            const properties = $el.DIV('l-form', [
                new UILabeled(region, { above: 'Region' }),
                new UILabeled(portal_id, { above: 'Portal Id' }),
                new UILabeled(form_id, { above: 'Form Id' })
            ]);

            super($form({ region, portal_id, form_id }), container, 'Hubspot form', properties);

            this.ui_add($el.DIV('w-block', $el.P('bigtitle', 'Hubspot form 😵')));
        }
    }
};

export const ed_page_app_rating_block: EDBlockSpec<FPageBlock> = {
    key: 'app_rating',
    editor_block: class extends EDBlock {
        constructor(container: EDBlockContainer) {
            const split = new UICheckbox({ title: 'Split' });

            const properties = $el.DIV('l-form', [
                split,
            ]);

            super($form({ split }), container, 'App ratings', properties);

            const block = $el.DIV('blk-apprating b', [
                $el.DIV('r-rating', [
                    $el.ICON(UIIcon.BRAND_APPLE),
                    $el.DIV('r-text', '4.7'),
                    $el.DIV('r-stars', [makeStar(), makeStar(), makeStar(), makeStar(), makeStar(true)])
                ]),
                $el.DIV('r-rating', [
                    $el.ICON(UIIcon.BRAND_GOOGLE),
                    $el.DIV('r-text', '4.7'),
                    $el.DIV('r-stars', [makeStar(), makeStar(), makeStar(), makeStar(), makeStar(true)])
                ]),
            ]);

            $on(split, 'value', v => {
                block.classList.toggle('m-split', v);
            });

            this.ui_add(block);
        }
    }
};

export const ed_page_newsletter_block: EDBlockSpec<FPageBlock> = {
    key: 'newsletter',
    editor_block: class extends EDBlock {
        constructor(container: EDBlockContainer) {
            super($form({}), container, 'Newsletter');

            this.ui_add([
                $el.DIV('blk-newsletter', [
                    fakeInput("E-postadress"),
                    fakeInput("Välj stad"),
                    fakeButton("Skicka", 'k-shadow')
                ])
            ]);
        }
    },
};
